import { HTMLAttributes, RefObject } from "react"

import { classNames } from "../../../lib/classNames"

interface PopoverListProps extends HTMLAttributes<HTMLUListElement> {
  ref?: RefObject<HTMLUListElement | null>
}

const PopoverList = (props: PopoverListProps) => {
  const { ref, className, ...otherProps } = props

  return (
    <ul
      className={classNames(
        "max-h-73 space-y-1 overflow-y-auto p-1",
        className
      )}
      {...otherProps}
      ref={ref}
    />
  )
}

PopoverList.displayName = "PopoverList"

export default PopoverList
